export interface Crc32AuthKeyProvider {
  // 認証鍵は不変。readonly number[] で要素の書き換えも型で禁止する。
  readonly key: readonly number[]
}

export class FixedCrc32AuthKeyProvider implements Crc32AuthKeyProvider {
  constructor(readonly key: readonly number[] = [0x00, 0x00, 0x00, 0x00]) {}
}
